let isMaintenanceMode = false; // メンテナンス値を設定する (true: Maintenance Mode ON | false: Maintenance Mode OFF)

export const MaintenanceService = {
  setMaintenanceMode(status) {
    isMaintenanceMode = status;
  },
  isUnderMaintenance() {
    return isMaintenanceMode;
  },
};